import React from 'react'
import Banner from '../Components/Banner';
import ContactSection from '../Components/ContactSection';
import BannerImage from "../Images/home-banner.jpg";
import "./Css/Home.css";
import { Col, Container, Row, Image, Card, Carousel } from 'react-bootstrap';
import Img1 from "../Images/home/key-features.jpg";
import Ser1 from "../Images/services/Weddings.jpg";
import Ser2 from "../Images/services/Corporate Events.jpg";
import Ser3 from "../Images/services/Social Gathering.jpg";
import Ser4 from "../Images/services/Birthdays.jpg";
import Ser5 from "../Images/services/Cocktail Party.jpg";
import Ser6 from "../Images/services/House Warming.jpg";
import Ser7 from "../Images/services/Half Saree.jpg";
import Ser8 from "../Images/services/Dhothi Ceremony.jpg";
import testi1 from "../Images/home/testi1.jpg";
import testi2 from "../Images/home/testi2.jpg";
import testi3 from "../Images/home/testi3.jpg";
import testi4 from "../Images/home/testi4.jpg";
import userIcon from "../Images/testimonial-1.jpg";
import icon1 from "../Images/home/homeicon/1.svg";
import icon2 from "../Images/home/homeicon/2.svg";
import icon3 from "../Images/home/homeicon/3.svg";
import { Link } from 'react-router-dom';
import cer1 from '../Images/certificates/FireSafety.png';
import cer2 from '../Images/certificates/FoodSafety.png';
import cer3 from '../Images/certificates/FSSAI.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons';

const Home = () => {
  const bannerTitle = (
    <>
      Elevating events with taste, style, and sophistication.
    </>
  );
  const bannerContent = "Welcome to Sri Maha Caterers, where each event is elevated to a grand occasion. From the arrival of your guests to the last bite, they are treated to an experience of elegance, depth, and royal taste. Our food is prepared with the expertise of a five-star kitchen and the heart of tradition, presented with impeccable flair. With us, catering is not a service.";
  const bannerConclude = "A statement of luxury, elegance, and warm hospitality.";
  const serviceData = [
    {
      id: 1,
      title: 'Weddings',
      image: Ser1,
      description: 'Weddings',
      link: '/services/weddings'
    },
    {
      id: 2,
      title: 'Corporate Events',
      image: Ser2,
      description: 'Corporate Events',
      link: '/services/corporate-events'
    },
    {
      id: 3,
      title: 'Social Gathering',
      image: Ser3,
      description: 'Social Gathering',
      link: ''
    },
    {
      id: 4,
      title: 'Birthday Party',
      image: Ser4,
      description: 'Birthday Party',
      link: ''
    },
    {
      id: 5,
      title: 'Cocktail Party',
      image: Ser5,
      description: 'Cocktail Party',
      link: ''
    },
    {
      id: 6,
      title: 'House Warming Ceremony',
      image: Ser6,
      description: 'House Warming Ceremony',
      link: ''
    },
    {
      id: 7,
      title: 'HalfSaree Ceremony',
      image: Ser7,
      description: 'HalfSaree Ceremony',
      link: ''
    },
    {
      id: 8,
      title: 'Dhothi Ceremony',
      image: Ser8,
      description: 'Dhothi Ceremony',
      link: ''
    }
  ];
  const testimonialData = [
    {
      id: 1,
      name: 'Radhika & Anirudh',
      role: 'Hyderabad',
      image: userIcon,
      quote: 'Sri Maha Caterers made our wedding banquet a royal one. Every course was not just delicious but laid out beautifully. Folks are still talking about the biryani and the live dessert counter! Absolutely top-class service from start to finish.'
    },
    {
      id: 2,
      name: 'Meghana R',
      role: 'Banjara Hills',
      image: userIcon,
      quote: 'From the initial tasting to the final plate served, Sri Maha Caterers made our wedding celebration feel opulent and intimate. Their detail and dedication to quality made all the difference.'
    },
    {
      id: 3,
      name: 'Ramesh & Family',
      role: '--',
      image: userIcon,
      quote: "We needed a classy but warm touch for our father's 60th birthday, and Sri Maha Caterers provided exactly that. The taste was traditional, the serving staff was courteous and attentive, and everything was expertly handled."
    }
  ];
  
  return (
    <div className='home-content'>
      <Banner image={BannerImage} propAlt={"Home Banner"} 
          bannerTitle={bannerTitle} bannerContent={bannerContent} bannerConclude={bannerConclude} />        
        <section className='sec-one mt-3 mb-3'>
          <Container>
            <p className='m-4 text-center'>
            Personalize your menu experience. <Link to='/contact#enquiry'  className='ml-2 d-inline-block btn-style'> Request Now</Link>
            </p>
          </Container>
        </section>
        <section className='sec-two section-pad'>
          <Container>
            <Row className='d-flex align-items-center justify-content-center'>
              <Col xs={12} sm={12} md={12} lg={6}>

                <div className='img-style d-flex align-items-center justify-content-center'>
                  <div className='img'>
                    <Image className='img-responsive' src={Img1} alt="Key Features" />
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={12} md={12} lg={6}>
                <h2 className='mb-5'>Key Features</h2>
                <p className='d-flex gap-5 align-items-center mb-5'>
                  <span className='icon red-icon'>
                    <Image src={icon1} alt='icon' />   
                  </span>
                  <span className='keypoint'>
                    30+ Years of culinary excellence
                  </span>
                </p>
                <p className='d-flex gap-5 align-items-center mb-5'>
                  <span className='icon yellow-icon'>
                    <Image src={icon2} alt='icon' />   
                  </span>
                  <span className='keypoint'>
                    ISO XXXX:XXX certified
                  </span>
                </p>
                <p className='d-flex gap-5 align-items-center mb-5'>
                  <span className='icon green-icon'>
                    <Image src={icon3} alt='icon' />   
                  </span>
                  <span className='keypoint'>
                    6000+ meals served every day
                  </span>
                </p>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="services-section py-5">
          <Container>
            
            <h2 className="text-center mb-5">Elegant Dining Experiences in</h2>
            
            <Row className="g-4">
              {serviceData.map((service, index) => (
                <Col key={service.id} xs={12} sm={6} md={4} lg={3}>
                  <Card className={`service-card h-100 ${((index + 1) % 2 === 0) ? 'mt-5' : ''}`}>
                    <div className="card-img-wrapper">
                      <Card.Img variant="top" src={service.image} alt={service.title} />
                    </div>
                    <Card.Body>
                      <Card.Title>
                        {service.link && service.link !== "" ? (
                          <Link
                          to={service.link}
                          className="stretched-link text-decoration-none text-dark d-flex align-items-center justify-content-center gap-3"
                        >
                          {service.title} <FontAwesomeIcon icon={faAngleDoubleRight} />
                        </Link>

                        ) : (
                          <div className="stretched-link text-decoration-none text-dark">
                            {service.title}
                          </div>
                        )}
                      </Card.Title>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
        <section className='section-pad client-sec'>
          <Container>
            <h3 className='title text-center mb-5'>
              Certifications & Licenses
            </h3>
            <Row className='d-flex align-items-center justify-content-center  mb-5'>
              <Col xs={12} lg={4}>
                <div className='icon-bg'>
                  <img className='img-responsive' src={cer1} alt='client' />
                </div>
              </Col>
              <Col xs={12} lg={4}>
                <div className='icon-bg'>
                  <img className='img-responsive' src={cer2} alt='client' />
                </div>
              </Col>
              <Col xs={12} lg={4}>
                <div className='icon-bg'>
                  <img className='img-responsive' src={cer3} alt='client' />
                </div>
              </Col>
              </Row>
              
          </Container>
        </section>
        <section className="testimonials-section section-pad">
          <Container>
            
          <h2 className="text-center mb-2">Testimonials</h2>
          <p className="text-center mb-5">Look what our happy customers say</p>
          <Row className="d-flex align-items-stretch justify-content-center top-testi">
            <Col xs={12} lg={4} className="d-flex flex-column justify-content-center h-100 mb-4 mb-lg-0">
              <img className="img-responsive w-100" src={testi1} alt="" />
            </Col>

            <Col xs={12} lg={4} className="d-flex flex-column justify-content-center h-100 mb-4 mb-lg-0">
              <img className="img-responsive w-100" src={testi2} alt="" />
            </Col>

            <Col xs={12} lg={4} className="d-flex flex-column justify-content-between h-100">
              <Row className="d-flex flex-column gap-4 h-100">
                <Col className="h-50">
                  <img className="img-responsive w-100 h-100 object-fit-cover" src={testi3} alt="" />
                </Col>
                <Col className="h-50">
                  <img className="img-responsive w-100 h-100 object-fit-cover" src={testi4} alt="" />
                </Col>
              </Row>
            </Col>
          </Row>


            <Row className="justify-content-center">
              <Col sm={8} md={12} className="justify-content-center">
                <Carousel className="testimonial-carousel">
                  {testimonialData.map((testimonial) => (
                    <Carousel.Item key={testimonial.id}>
                      <div className="testimonial-item text-center d-flex align-items-center justify-content center">
                        <Row>
                          <Col xs="3">
                            <div className="testimonial-img-wrapper mb-4">
                              <img
                                src={testimonial.image}
                                alt={testimonial.name}
                                className="rounded-circle"
                              />
                            </div>
                          </Col>
                          <Col xs="9">
                            <blockquote className="mb-4">
                              <p className="quote">{testimonial.quote}</p>
                            </blockquote>
                            <h4 className="testimonial-name">{testimonial.name}</h4>
                            <p className="testimonial-role">{testimonial.role}</p>
                          </Col>
                        </Row>
                      </div>
                    </Carousel.Item>
                  ))}
                </Carousel>
              </Col>
            </Row>
          </Container>
        </section>
        <ContactSection />
    </div>
  )
}

export default Home;
